<template>
  <GenericProgressLinear :icon="'mdi-book-open-page-variant'" :title="'Quests'" :stats="stats"></GenericProgressLinear>
</template>


<script>
import { mapGetters } from "vuex"
import GenericProgressLinear from "./GenericProgressLinear"

export default {
  name: "QuestsProgressLinear",
  components: { GenericProgressLinear },
  computed: {
    ...mapGetters("entities/quests",["stats"])
  },
};
</script>
